import { CalendarEventParticipantResponseType } from "./CalendarEventParticipantResponseType";

export class CalendarEventParticipant {
    calendarEventId = 0;
    userId: number = null;
    mail: string;
    responseType: CalendarEventParticipantResponseType = CalendarEventParticipantResponseType.none;
    id = 0;
}
